module.exports = __webpack_public_path__ + "assets/img/carousel_4.ffdcdb94.png";